import { useForm } from "react-hook-form";

const SearchForm = ({ onSearch, isLoading }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm();
  const refNo = watch("refNo");

  const handleChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9]/g, "");
    value = value.toUpperCase();
    setValue("refNo", value, { shouldValidate: true });
  };

  const onSubmit = (data) => {
    onSearch(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="idu-form-group">
        <label className="d-block idu-label" htmlFor="client-search">
          Reference No
        </label>
        <input
          className="idu-input w-100"
          id="client-search"
          placeholder="Enter here"
          value={refNo || ""}
          {...register("refNo", {
            required: true,
            minLength: {
              value: 10,
              message: "Minimum 10 characters required",
            },
            maxLength: {
              value: 20,
              message: "Maximum 20 characters allowed",
            },
            onChange: handleChange,
          })}
        />
        {errors?.refNo?.message && (
          <p className="idu-error-text">{errors.refNo.message}</p>
        )}
      </div>

      <button
        style={{ padding: "0.9rem 2.4rem", marginTop: "2.6rem" }}
        className="idu-btn-primary"
        disabled={!isValid}
      >
        {isLoading ? "LOADING..." : "SEARCH"}
      </button>
    </form>
  );
};

export default SearchForm;
